import { createSlice } from '@reduxjs/toolkit'

export const sourcesSlice = createSlice({
  name: 'sources',
  initialState: {
    value: [
       '/data/data.json',
       '/data/stops.json',
    ],
  },
  reducers: {
    change: (state) => {
  
      state.value =[ '/data/data.json',
      '/data/stops.json',
      ]
    },
    
   
  },
})

// Action creators are generated for each case reducer function
export const { changeToGrid, changeToRefined } = sourcesSlice.actions

export default sourcesSlice.reducer